/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractBinderDto } from './ContractBinderDto';
import {
    ContractBinderDtoFromJSON,
    ContractBinderDtoFromJSONTyped,
    ContractBinderDtoToJSON,
    ContractBinderDtoToJSONTyped,
} from './ContractBinderDto';

/**
 * 
 * @export
 * @interface CreateBinderClaimPayloadDto
 */
export interface CreateBinderClaimPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBinderClaimPayloadDto
     */
    claimId: string;
    /**
     * 
     * @type {Array<ContractBinderDto>}
     * @memberof CreateBinderClaimPayloadDto
     */
    contracts: Array<ContractBinderDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderClaimPayloadDto
     */
    claimStatus: CreateBinderClaimPayloadDtoClaimStatusEnum;
}


/**
 * @export
 */
export const CreateBinderClaimPayloadDtoClaimStatusEnum = {
    PreCautionary: 'Pre-cautionary',
    Registered: 'Registered',
    InProgress: 'In-progress',
    Closed: 'Closed'
} as const;
export type CreateBinderClaimPayloadDtoClaimStatusEnum = typeof CreateBinderClaimPayloadDtoClaimStatusEnum[keyof typeof CreateBinderClaimPayloadDtoClaimStatusEnum];


/**
 * Check if a given object implements the CreateBinderClaimPayloadDto interface.
 */
export function instanceOfCreateBinderClaimPayloadDto(value: object): value is CreateBinderClaimPayloadDto {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('contracts' in value) || value['contracts'] === undefined) return false;
    if (!('claimStatus' in value) || value['claimStatus'] === undefined) return false;
    return true;
}

export function CreateBinderClaimPayloadDtoFromJSON(json: any): CreateBinderClaimPayloadDto {
    return CreateBinderClaimPayloadDtoFromJSONTyped(json, false);
}

export function CreateBinderClaimPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBinderClaimPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'contracts': ((json['contracts'] as Array<any>).map(ContractBinderDtoFromJSON)),
        'claimStatus': json['claimStatus'],
    };
}

export function CreateBinderClaimPayloadDtoToJSON(json: any): CreateBinderClaimPayloadDto {
    return CreateBinderClaimPayloadDtoToJSONTyped(json, false);
}

export function CreateBinderClaimPayloadDtoToJSONTyped(value?: CreateBinderClaimPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'contracts': ((value['contracts'] as Array<any>).map(ContractBinderDtoToJSON)),
        'claimStatus': value['claimStatus'],
    };
}

